import { render } from "./DefaultFooter.vue?vue&type=template&id=7c218772"
const script = {}

import "./DefaultFooter.vue?vue&type=style&index=0&id=7c218772&lang=css"

import exportComponent from "C:\\Users\\Urakehn\\Documents\\Developpement\\R42\\EasyProf_landing\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__